module.exports = __webpack_public_path__ + "img/logo_yelp@3x.9330a7a2.png";